import XAutofocus from "./directives/XAutofocus"
import XNavMenu from "./components/XNavMenu.vue"
import XConfirmDialog from "./components/XConfirmDialog.vue"
import XBasicBtn from "./components/XBasicBtn.vue"
import XCardBasedForm from "./components/XCardBasedForm.vue"
import veeValidate from "@vuetifyx/plugins/veeValidate";


export default {
  install(Vue, options) {
    Vue.directive("XAutofocus", XAutofocus)
    Vue.component("XNavMenu", XNavMenu)
    Vue.component("XConfirmDialog", XConfirmDialog)
    Vue.component("XBasicBtn", XBasicBtn)
    Vue.component("XCardBasedForm", XCardBasedForm)

    veeValidate.install(Vue)

    Vue.directive('XAutofocus', {
      bind: (el, binding, vnode) => {
        setTimeout(() => {
          el.focus()
          const input = el.querySelector("input")
          if (input && !vnode.context.$vuetify.breakpoint.mobile) {
            input.focus()
          }
        }, 100)
      }
    })
  }
}
